export enum InstallationType {
  MELTANO = 'meltano',
  AIRFLOW = 'airflow',
}
